<template>
<div class="login-container">
  <form @keydown.enter="login" @submit.prevent>
    <div class="login-message" v-if="loginMessage">
      {{loginMessage}}
    </div>
    <div class="login-inputs-container">
      <div>
        <InputTextField v-model="username" label="Username" ref="nameInput"></InputTextField>
        <InputTextField v-model="password" type="password" label="Password"></InputTextField>
      </div>
      <div v-if="loading" class="spinner-container">
        <div class="spinner-box">
          <Spinner class="spinner"/>
        </div>
      </div>
    </div>
    <div class="login-buttons">
      <button class="button primary" @click="login" :disabled="!canLogin">Login</button>
    </div>
  </form>

</div>
</template>

<script>
import InputTextField from '../components/forms/InputTextField';
import Spinner from '../components/Spinner.vue';

export default {
  name: 'page-login',
  components: { InputTextField, Spinner },
  mounted () {
    this.$refs.nameInput.focus();
  },
  data () {
    return {
      loginMessage: '',
      username: '',
      password: '',
      loading: false
    };
  },
  computed: {
    canLogin () {
      return !!(this.username) && !!(this.password) && !this.loading;
    },
  },
  methods: {
    login () {
      if (!this.canLogin) {
        return;
      }

      this.loading = true;
      this.loginMessage = '';
      const store = this.$store;
      store.dispatch('assetdb/login', {
        username: this.username,
        password: this.password
      }).then(() => {
        return this.refresh();
      }).then(() => {
        this.$router.push({ name: 'player.demo' });
      }).catch(() => {
        this.loginMessage = 'Wrong username or password';
        this.loading = false;
      });
    },
    refresh () {
      return this.$store.dispatch('assetdb/refresh');
    }
  }
};
</script>

<style lang="scss" >

@import '../style/color_';

.login-container {
  width: 300px;
  margin: auto;
  padding-top: 2rem
}

.login-message {
  text-align: center;
  color: $color-cl-red;
}

.login-buttons {
  text-align: center;
}

.login-inputs-container {
  position: relative;
}

.spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 50px;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-box {
  width: 40px;
  height: 40px;
}
</style>
